<!-- 图文导航 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1">样式设置</MenuItem>
                <MenuItem name="2">内容设置</MenuItem>
                <MenuItem name="3">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData.content" label-position="right" :label-width="100">
                        <div class="form-title">导航样式</div>
                        <FormItem label="导航样式">
                            <div class="flex-sb w80">
                                <div :class="newFormData.content.type_id == 1 ? 'nav-active' : 'nav'" @click="changeNav(1)">
                                    <img v-if="newFormData.content.type_id == 1" src="@/assets/icon1-active.png"/>
                                    <img v-else src="@/assets/icon1.png"/>
                                    <span>图标导航</span>
                                </div>
                                <div :class="newFormData.content.type_id == 2 ? 'nav-active' : 'nav'" @click="changeNav(2)">
                                    <img v-if="newFormData.content.type_id == 2" src="@/assets/icon2-active.png"/>
                                    <img v-else src="@/assets/icon2.png"/>
                                    <span>文字导航</span>
                                </div>
                                <div :class="newFormData.content.type_id == 3 ? 'nav-active' : 'nav'" @click="changeNav(3)">
                                    <img v-if="newFormData.content.type_id == 3" src="@/assets/icon3-active.png"/>
                                    <img v-else src="@/assets/icon3.png"/>
                                    <span>图片导航</span>
                                </div>
                            </div>
                        </FormItem>
                        <FormItem v-if="newFormData.content.type_id == 2" label="导航模式">
                            <RadioGroup v-model="newFormData.content.type_value" @on-change="changeTypeValue">
                                <Radio class="mr-24" label="1">宫格导航</Radio>
                                <Radio class="mr-24" label="2">顶部导航</Radio>
                            </RadioGroup>
                        </FormItem>
                        <template v-if="newFormData.content.type_id == 1 || ( newFormData.content.type_id == 2 && newFormData.content.type_value == 1)">
                            <div class="form-title">文字颜色</div>
                            <FormItem label="标题文字">
                                <ColorPicker v-model="newFormData.content.title_color"/>
                            </FormItem>
                            <FormItem label="功能阐述">
                                <ColorPicker v-model="newFormData.content.text_color"/>
                            </FormItem>
                        </template>
                        <template v-if="newFormData.content.type_id == 2 && newFormData.content.type_value == 2">
                            <div class="form-title">按钮设置</div>
                            <FormItem label="文字大小"><Input v-model="newFormData.content.txt_size" placeholder="请输入文字大小"><span slot="append">PX</span></Input></FormItem>
                            <FormItem label="选中文字">
                                <ColorPicker v-model="newFormData.content.txt_color_active"/>
                            </FormItem>
                            <FormItem label="未选中文字">
                                <ColorPicker v-model="newFormData.content.txt_color"/>
                            </FormItem>
                            <FormItem label="选中背景">
                                <div class="bg-upload" @click="openModal('active_img')">
                                    <Icon v-if="newFormData.content.active_img.picview" class="form-icon" size="22" type="ios-close-circle" color="#f00" @click.stop="delImg('active_img')"/>
                                    <img class="bg-img" v-if="newFormData.content.active_img.picview" :src="newFormData.content.active_img.picview"/>
                                    <Icon v-else type="md-add" size="30" color="#ccc"/>
                                </div>
                            </FormItem>
                            <FormItem label="导航背景">
                                <div class="bg-upload" @click="openModal('nav_img')">
                                    <Icon v-if="newFormData.content.nav_img.picview" class="form-icon" size="22" type="ios-close-circle" color="#f00" @click.stop="delImg('nav_img')"/>
                                    <img class="bg-img" v-if="newFormData.content.nav_img.picview" :src="newFormData.content.nav_img.picview"/>
                                    <Icon v-else type="md-add" size="30" color="#ccc"/>
                                </div>
                            </FormItem>
                            <div class="form-title">图文设置</div>
                            <FormItem label="文字大小"><Input v-model="newFormData.content.clerk_size" placeholder="请输入文字大小"><span slot="append">PX</span></Input></FormItem>
                            <FormItem label="文字颜色">
                                <ColorPicker v-model="newFormData.content.clerk_color"/>
                            </FormItem>
                        </template>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                        <FormItem label="背景图">
                            <i-switch v-model="newFormData.content.bg_value" size="large" true-color="#FF761D" :true-value="1" :false-value="0" @on-change="changeBgValue">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem v-if="newFormData.content.bg_value" label="上传背景">
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img class="bg-img" v-if="newFormData.content.bg_img.picview" :src="newFormData.content.bg_img.picview"/>
                                <Icon v-else type="md-add" size="30" color="#ccc"/>
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <div class="right-navs">
                        <div class="right-nav" v-for="(item, index) of newFormData.content.iconList" :key="index">
                            <img class="del-img" src="@/assets/del.png" @click.stop="delIcons(index)"/>
                            <div class="right-uploads" v-if="newFormData.content.type_id == 1 || newFormData.content.type_id == 3" @click="openModal(index)">
                                <img class="upload-img" v-if="item.picview" :src="item.picview"/>
                                <Icon v-else type="md-add" size="50" color="#C0C4CC"/>
                            </div>
                            <div style="flex: 1">
                                <Input v-if="newFormData.content.type_id == 1 || newFormData.content.type_id == 2" v-model="item.title" placeholder="请输入标题">
                                    <span slot="prepend">标题</span>
                                </Input>
                                <Input class="mt-6" v-if="newFormData.content.type_id == 1 || ( newFormData.content.type_id == 2 && newFormData.content.type_value == 1)" v-model="item.describe" placeholder="请输入功能阐述" >
                                    <span slot="prepend">说明</span>
                                </Input>
                                <Select class="mt-6" v-model="item.action_id" filterable placeholder="跳转动作">
                                    <Option v-for="item in actionList" :value="item.id" :key="item.id" >{{ item.name }}</Option>
                                </Select>
                                <Input class="mt-6" v-if="item.action_id == 1" v-model="item.link_name" placeholder="请输入外部链接（http/https）"></Input>
                                <Select class="mt-6" v-if="item.action_id == 2" v-model="item.link_id" filterable placeholder="请选择跳转页面">
                                    <Option v-for="item in linkList" :value="item.id" :key="item.id" >{{ item.title }}</Option>
                                </Select>
                                <template v-if="newFormData.content.type_value == 2 && item.action_id == 4">
                                    <Input class="mt-6" v-model="item.clerk" placeholder="请输入文案详情">
                                        <span slot="prepend">文案</span>
                                    </Input>
                                    <div v-for="(e, i) of item.imgList" :key="i">
                                        <div class="report-div" @click="openModal('report-img', index, i)">
                                            <img class="del-reportimg" src="@/assets/del.png" @click.stop="delReportImg(index, i)"/>
                                            <img v-if="e.picview" :src="e.picview" class="report-img"/>
                                            <template v-else>
                                                <div class="report-txt">(建议780*450px)</div>
                                                <Icon class="report-icon" type="md-add"/>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="add-div" @click="addReportImg(index)">
                                        <img class="add-img" src="@/assets/plus.png"/>
                                        <div class="add-txt" >添加</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="add-div" @click="addIcons">
                            <img class="add-img" src="@/assets/plus.png"/>
                            <div class="add-txt">添加</div>
                        </div>
                    </div>
                </div>
                <div v-if="name_id == 3">
                    <Form :model="newFormData" label-position="right" :label-width="80">
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.marginData" class="w300" show-input v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider v-if="newFormData.content.paddingData" class="w300" show-input v-model="newFormData.content.paddingData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.top"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider v-if="newFormData.content.radiusData" class="w300" show-input v-model=" newFormData.content.radiusData.bottom"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary 
            v-if="switch_modal" 
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        diy_id: {
            type: String,
            default: "0",
        },
        newFormData: {
            type: Object,
            default: {},
        },
        linkList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            srctype: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            actionList: [],
            add_value1: '',
            add_value2: '',
        };
    },
    mounted() {
        if(this.newFormData.content.type_value == 2){
            this.actionList = [
                { id: 1, name: "跳转外部链接" },
                { id: 2, name: "跳转页面" },
                { id: 3, name: "扫一扫" },
                { id: 4, name: "文案详情" },
            ];
        }else {
            if (this.diy_id == 1) {
                this.actionList = [
                    { id: 1, name: "跳转外部链接" },
                    { id: 2, name: "跳转页面" },
                    { id: 3, name: "扫一扫" },
                ];
            } else if (this.diy_id == 2) {
                this.actionList = [
                    { id: 1, name: "跳转外部链接" },
                    { id: 3, name: "扫一扫" },
                ];
            }
        }
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if(this.srctype == 'bg_img'){
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.bg_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.bg_img.value = param2[i];
                }
            }else if(this.srctype == 'active_img'){
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.active_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.active_img.value = param2[i];
                }
            }else if(this.srctype == 'nav_img'){
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.nav_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.nav_img.value = param2[i];
                }
            }else if(this.srctype == 'report-img'){
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.iconList[this.add_value1].imgList[this.add_value2].picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.iconList[this.add_value1].imgList[this.add_value2].value = param2[i];
                }
            }else{
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.iconList[this.srctype].picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.iconList[this.srctype].value = param2[i];
                }
            }
            this.$Message.destroy();
        },
        openModal(index, add_value1, add_value2) {
            this.switch_modal = true;
            this.srctype = index;
            this.add_value1 = add_value1
            this.add_value2 = add_value2
        },
        selectName(name) {
            this.name_id = name;
        },
        changeNav(i) {
            this.newFormData.content.type_id = i;
        },
        // 删除
        delIcons(i) {
            if (this.newFormData.content.iconList.length == 1) {
                this.$Message.info("至少保留一张");
            } else {
                this.newFormData.content.iconList.splice(i, 1);
            }
        },
        // 添加
        addIcons() {
            this.newFormData.content.iconList.push({
                value: "/icon/diys/smail.png",
                picview: "https://suyuan.hulianzaowu.com/icon/diys/smail.png",
                title: "标题",
                describe: "功能阐述",
                action_id: 1,
                link_id: 1,
                link_name: "",
                imgList: [{ value: '', picview: "" }],
                clerk: '文案标题',
                clerk_value: 0,
            });
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        // 删除
        delReportImg(index, i) {
            if (this.newFormData.content.iconList[index].imgList.length == 1) {
                this.$Message.info("至少保留一张");
            } else {
                this.newFormData.content.iconList[index].imgList.splice(i, 1);
            }
        },
        // 添加
        addReportImg(index) {
            this.newFormData.content.iconList[index].imgList.push({
                value: "",
                picview: ""
            });
        },
        changeTypeValue(event){
            if(event == 2){
                this.actionList = [
                    { id: 1, name: "跳转外部链接" },
                    { id: 2, name: "跳转页面" },
                    { id: 3, name: "扫一扫" },
                    { id: 4, name: "文案详情" },
                ];
            }else {
                if (this.diy_id == 1) {
                    this.actionList = [
                        { id: 1, name: "跳转外部链接" },
                        { id: 2, name: "跳转页面" },
                        { id: 3, name: "扫一扫" },
                    ];
                } else if (this.diy_id == 2) {
                    this.actionList = [
                        { id: 1, name: "跳转外部链接" },
                        { id: 3, name: "扫一扫" },
                    ];
                }
            }
        },
        delImg(index){
            if(index == 'active_img'){
                this.newFormData.content.active_img.picview = ''
            }else if(index == 'nav_img'){
                this.newFormData.content.nav_img.picview = ''
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.w80 {
    width: 80%;;
}
.nav {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.nav-active {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #fe761d;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #fe761d;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.right-navs {
    padding: 12px;
    width: 100%;
    border: 1px solid #c0c4cc;
}
.right-nav {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #c0c4cc;
    display: flex;
    position: relative;
}
.del-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    cursor: pointer;
    width: 30px;
    height: 30px;
}
.right-uploads {
    margin: 0 12px 0 0;
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.upload-img {
    width: 100%;
    height: 100%;
}
.mt-6 {
    margin: 6px 0 0 0;
}
.add-div {
    display: flex;
    cursor: pointer;
}
.add-img {
    width: 22px;
    height: 22px;
    margin-right: 6px;
}
.add-txt {
    font-size: 15px;
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.report-div {
    margin: 12px 0;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    position: relative;
    border: 1px solid #c0c4cc;
    cursor: pointer;
}
.report-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.del-reportimg {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 99;
    width: 26px !important;
    height: 26px !important;
    cursor: pointer;
}
.report-txt {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    font-size: 14px;
    color: #747B95;
}
.report-icon {
    position: absolute;
    font-size: 50px;
    color: #c0c4cc;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
}
.form-icon {
    position: absolute;
    top: -10px;
    left: 70px;
}
</style>